import getUserUnlockFeatures from "../libs/getUserUnlockFeatures";
import { compose, lifecycle, withHandlers, withState, withProps } from "recompose";
import getUserPurchase from "../libs/getUserPurchases";

export const withUserLockedFeatures = compose(
  withState("userPurchaseVideo", "setUserPurchaseVideo", false),
  withState("userPurchaseWatermark", "setUserPurchaseWatermark", false),
  withState("userPurchasesLoading", "setUserPurchasesLoading", true),
  withState("settings", "setSettings", {}),
  withProps(({ settings }) => ({
    ...settings,
  })),
  withProps(({ videoFeatureLocked, userPurchaseVideo }) => ({
    isVideoLocked: !userPurchaseVideo && videoFeatureLocked,
    // isWatermarkLocked: !userPurchaseWatermark && watermarkFeatureLocked,
  })),
  withHandlers({
    fetchUnlockedFeatures: props => () => {
      return getUserUnlockFeatures().then(lockedFeatures => {
        const settings = {
          videoFeatureLocked: lockedFeatures.lockedVideo,
          watermarkFeatureLocked: lockedFeatures.lockedWatermark,
          videoPrice: lockedFeatures.videoPrice,
          watermarkPrice: lockedFeatures.watermarkPrice,
          unlockTopNinePrice: lockedFeatures.unlockTopNinePrice,
          showBlockingModalInGrid: !lockedFeatures.watermarkPurchaseEnabled,
          videoFeatureEnabled: lockedFeatures.videoFeatureEnabled,
          gridDelay: lockedFeatures.gridDelay,
          exceptionsWithPaymentButton: lockedFeatures.exceptionsWithPaymentButton,
        };
        props.setSettings(settings);
        return lockedFeatures;
      });
    },
    refetchUserPurchases: ({ setUserPurchaseVideo, setUserPurchasesLoading }) => () => {
      setUserPurchasesLoading(true);
      getUserPurchase().then(purchases => {
        if (purchases) {
          setUserPurchaseVideo(purchases.videoPurchased || false);
          setUserPurchasesLoading(false);
        }
      });
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchUnlockedFeatures();
    },
  })
);
